export default __webpack_public_path__ + "static/media/proof.b7aae290.webp";